import React from 'react';
import PropTypes from 'prop-types';

export function Wrapper(props) {
  return <div className={props.className}>{props.children}</div>;
}

Wrapper.defaultProps = {
  className: '',
};

Wrapper.propTypes = {
  /**
   * Component/Components to display on Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * className for overlay and content tags
   */
  className: PropTypes.string,
};
